export const isSku = (possibleSku: string) =>
    !!possibleSku &&
    !!possibleSku.match(new RegExp(/^[0-9]+$/)) &&
    possibleSku.length > 3;
